import { ref as b, computed as R, watch as W, withDirectives as q, createElementBlock as l, openBlock as s, createElementVNode as _, createCommentVNode as y, Fragment as D, renderList as T, createBlock as N, withCtx as v, createVNode as p, mergeProps as G, withKeys as E, unref as d, normalizeClass as c, createTextVNode as C, toDisplayString as A, renderSlot as H } from "vue";
import S from "../../../atoms/icon-core/icon-core.vue.js";
import L from "../../../atoms/anchor-element/anchor-element.vue.js";
import J from "../../../molecules/link/link.vue.js";
import M from "../../../tracking/tracking-constants.js";
import Q from "../../../utils/directives/click-outside.js";
import { scrollAwds as U } from "../../../utils/directives/scroll.js";
import { themeProp as X } from "../../../composables/useTheme.js";
import { screenProp as Y } from "../../../utils/utilsScreen.js";
import { useTracking as Z } from "../../../composables/useTracking.js";
import V from "./header-subnavigation-horizontal.vue.js";
import j from "./header-navigation-horizontal-slide-over.vue.js";
/* empty css                                  */
const ee = ["aria-label"], te = ["aria-label"], ae = ["aria-expanded", "data-track-component-name", "data-track-text", "onFocusout", "onClick"], ne = {
  key: 0,
  class: "ds-header-navigation__items__item ds-header-navigation__items__item--flex-grow",
  role: "none"
}, oe = ["aria-expanded", "data-track-component-name", "data-track-text", "data-track-id"], ie = { class: "ds-header-navigation__search" }, re = { class: "ds-container ds-padding-y-96 ds-height-full" }, se = {
  key: 2,
  class: "ds-header-navigation__items__item"
}, $ = "search-item", be = /* @__PURE__ */ Object.assign({
  name: "DsHeaderNavigationHorizontal"
}, {
  __name: "header-navigation-horizontal",
  props: {
    ...X,
    ...Y,
    primaryItems: { type: Array, default: () => [] },
    secondaryItems: { type: Array, default: () => [] },
    ctaItem: { type: Object, default: null },
    labels: { type: Object, required: !0 }
  },
  emits: ["dropdown-opened", "dropdown-closed", "slide-over-closed", "slide-over-opened"],
  setup(n, { emit: F }) {
    const z = U(), { provideTrackingData: P, trackingDataProvided: h } = Z();
    P(M);
    const O = n, I = F, i = b(null), f = b(""), g = b(!1), w = b({}), k = R(() => i.value === $);
    W(i, (t, a) => {
      var o;
      f.value = t === null || t === 0, (a === null || a === 0) && (f.value = !0);
      const e = t || a, r = e === $ ? O.labels.searchLabel : (o = O.primaryItems.find((K) => K.id === e)) == null ? void 0 : o.title;
      I(`${t ? "dropdown-opened" : "dropdown-closed"}`, { label: r });
    });
    function u(t) {
      i.value = t;
    }
    function m() {
      !i.value || i.value === $ || (i.value = null, document.activeElement.blur());
    }
    function x(t, a) {
      var r, o;
      const e = Array.isArray(w.value[a]) ? (r = w.value[a][0]) == null ? void 0 : r.$el : (o = w.value[a]) == null ? void 0 : o.$el;
      t.relatedTarget && !(e != null && e.contains(t.relatedTarget)) && !g.value && i.value && u(0);
    }
    function B() {
      k.value ? (u(0), I("slide-over-closed")) : (u($), I("slide-over-opened"));
    }
    return (t, a) => q((s(), l("nav", {
      "aria-label": n.labels.ariaLabelNavigation,
      class: "ds-header-navigation"
    }, [
      _("ul", {
        "aria-label": n.labels.ariaLabelNavigation,
        class: "ds-header-navigation__items",
        role: "menubar"
      }, [
        (s(!0), l(D, null, T(n.primaryItems, (e, r) => (s(), l("li", {
          key: `primary_${r}`,
          class: "ds-header-navigation__items__item",
          role: "none"
        }, [
          e.items ? (s(), N(j, {
            key: 0,
            ref_for: !0,
            ref: (o) => w.value[`nav_item_${r}`] = o,
            "with-transition": f.value,
            opened: i.value === e.id
          }, {
            button: v(() => [
              _("button", {
                type: "button",
                role: "menuitem",
                "aria-haspopup": "true",
                "aria-expanded": (i.value === e.id).toString(),
                class: c(["ds-header-navigation__button ds-white-space-nowrap", [
                  `ds-header-navigation__button--${t.theme}`,
                  { "ds-header-navigation__button--active": i.value === e.id }
                ]]),
                "data-track-component-name": d(h)["component-name"] || t.$options.name,
                "data-track-text": e.title,
                "data-track-level": "1",
                onFocusout: (o) => x(o, `nav_item_${r}`),
                onKeydown: a[0] || (a[0] = E((o) => u(0), ["esc"])),
                onMousedown: a[1] || (a[1] = (o) => g.value = !0),
                onMouseup: a[2] || (a[2] = (o) => g.value = !1),
                onClick: (o) => u(i.value === e.id ? 0 : e.id)
              }, [
                C(A(e.title) + " ", 1),
                p(S, {
                  category: "arrows",
                  class: "ds-header-navigation__button__icon",
                  name: "chevron-down-small"
                })
              ], 42, ae)
            ]),
            content: v(() => [
              p(V, G({ ref_for: !0 }, e, { onLinkClicked: m }), null, 16)
            ]),
            _: 2
          }, 1032, ["with-transition", "opened"])) : (s(), N(L, {
            key: 1,
            "tracking-data": { "component-name": t.$options.name, text: e.title, level: 1, ...d(h) },
            url: e.url,
            "open-in-new-window": e.openInNewWindow,
            nuxt: e.nuxt,
            class: c([`ds-header-navigation__button--${t.theme}`, "ds-header-navigation__button ds-white-space-nowrap"]),
            role: "menuitem",
            onClick: m
          }, {
            default: v(() => [
              C(A(e.title), 1)
            ]),
            _: 2
          }, 1032, ["tracking-data", "url", "open-in-new-window", "nuxt", "class"]))
        ]))), 128)),
        t.$slots.search ? (s(), l("li", ne, [
          p(j, {
            ref: (e) => w.value.nav_item_search = e,
            "with-transition": f.value,
            opened: k.value
          }, {
            button: v(() => [
              _("button", {
                type: "button",
                role: "menuitem",
                "aria-haspopup": "true",
                "aria-expanded": k.value.toString(),
                class: c(["ds-header-navigation__button", [
                  `ds-header-navigation__button--${t.theme}`,
                  { "ds-header-navigation__button--active": k.value }
                ]]),
                "data-j-search": "",
                "data-track-component-name": d(h)["component-name"] || t.$options.name,
                "data-track-text": n.labels.searchLabel,
                "data-track-id": d(M).id.SEARCH,
                "data-track-level": "1",
                onFocusout: a[3] || (a[3] = (e) => x(e, "nav_item_search")),
                onMousedown: a[4] || (a[4] = (e) => g.value = !0),
                onMouseup: a[5] || (a[5] = (e) => g.value = !1),
                onKeydown: a[6] || (a[6] = E((e) => u(0), ["esc"])),
                onClick: B
              }, [
                p(S, {
                  category: "interface",
                  name: "search"
                })
              ], 42, oe)
            ]),
            content: v(() => [
              _("div", ie, [
                _("div", re, [
                  H(t.$slots, "search")
                ])
              ])
            ]),
            _: 3
          }, 8, ["with-transition", "opened"])
        ])) : y("", !0),
        (s(!0), l(D, null, T(n.secondaryItems, (e, r) => (s(), l("li", {
          key: `secondary_${r}`,
          class: c(["ds-header-navigation__items__item", { "ds-header-navigation__items__item--flex-grow": r === 0 && !t.$slots.search }]),
          role: "none"
        }, [
          p(L, {
            "tracking-data": { "component-name": t.$options.name, text: e.title, level: 1, ...d(h) },
            url: e.url,
            "open-in-new-window": e.openInNewWindow,
            nuxt: e.nuxt,
            class: c([`ds-header-navigation__button--${t.theme}`, "ds-header-navigation__button ds-white-space-nowrap"]),
            role: "menuitem",
            onClick: m
          }, {
            default: v(() => [
              e.icon ? (s(), N(S, {
                key: 0,
                class: c(["ds-margin-right-8", e.icon.class]),
                category: e.icon.category,
                name: e.icon.name,
                "data-j-icon": ""
              }, null, 8, ["class", "category", "name"])) : y("", !0),
              C(" " + A(e.title), 1)
            ]),
            _: 2
          }, 1032, ["tracking-data", "url", "open-in-new-window", "nuxt", "class"])
        ], 2))), 128)),
        n.ctaItem ? (s(), l("li", {
          key: 1,
          class: c(["ds-header-navigation__items__item", { "ds-header-navigation__items__item--flex-grow": n.secondaryItems.length === 0 && !t.$slots.search }]),
          role: "none"
        }, [
          p(J, {
            "tracking-data": { "component-name": t.$options.name, text: n.ctaItem.title, level: 1, ...d(h) },
            url: n.ctaItem.url,
            "open-in-new-window": n.ctaItem.openInNewWindow,
            nuxt: n.ctaItem.nuxt,
            content: n.ctaItem.title,
            color: t.theme === "green" ? "black" : null,
            type: "button",
            role: "menuitem",
            class: "ds-white-space-nowrap",
            onClick: m
          }, null, 8, ["tracking-data", "url", "open-in-new-window", "nuxt", "content", "color"])
        ], 2)) : y("", !0),
        t.$slots["locale-switcher"] ? (s(), l("li", se, [
          H(t.$slots, "locale-switcher", { theme: t.theme })
        ])) : y("", !0)
      ], 8, te)
    ], 8, ee)), [
      [d(z), m],
      [d(Q), m]
    ]);
  }
});
export {
  be as default
};
